<template>
  <div class="box">
    <div
      class="b-research"
      @click="submitButton(info.activity_type)"
      style="cursor: pointer"
    >
      <slot name="box-img">
        <img v-complete:src="info.image" alt="" />
      </slot>
      <slot name="boxContent">
        <div class="box-title">
          <p class="title-p">
            {{ info.title }}
            <!-- 考试改革和课程标准的要求《国家中长期教育改革和发展规划纲要(20xx—20xx年)》在"考试发展规划纲要(20xx—20xx年)》在"考试中111111111111111111222222222222222222222222 -->
          </p>
          <slot name="details">
            <div class="icon-box">
              <el-icon><Calendar /></el-icon>
              <p>
                项目时间：
                <span>
                  {{ dayjs(info.start_time * 1000).format("YYYY-MM-DD") }}~{{
                    dayjs(info.end_time * 1000).format("YYYY-MM-DD")
                  }}</span
                >
              </p>
            </div>
            <div class="icon-box">
              <el-icon><User /></el-icon>
              <p>
                参与对象：
                <span>{{ info.participant }}</span>
              </p>
            </div>
            <div class="icon-box icon-box1">
              <el-icon><Document /></el-icon>
              <p>
                项目说明：
                <span>{{ info.intro }}</span>
              </p>
            </div>
          </slot>

          <slot name="collect"></slot>
          <!-- <el-button type="primary" 
            >查看详情</el-button
          > -->
        </div>
      </slot>
    </div>
    <el-button
      type="primary"
      plain
      class="upload-file-btn"
      v-if="props.showUploadFileBtn"
      @click="btnClick(info)"
      >上传文件</el-button
    >
    <el-button
      type="primary"
      plain
      class="upload-file-btn"
      v-if="props.showViewWorksBtn"
      @click="btnClick2(info)"
      >我的作品</el-button
    >

    <!-- 弹窗区域 -->
    <el-dialog v-model="mydata.dialogVisible" title="我的作品" width="343">
      <el-form
        ref="formEl2"
        :model="mydata.form2"
        :rules="mydata.rules2"
      >
        <!-- <img
          style="width: 291px"
          v-complete:src="props.studentApplyInfoObj.files"
          alt=""
        /> -->
      
        <!-- 可支持word文稿和pdf格式文件上传的相关代码 -->
        <template v-if="props.studentApplyInfoObj.files">
          <img
            v-if="getFileType(props.studentApplyInfoObj.files) === 'image'"
            style="width: 291px"
            v-complete:src="props.studentApplyInfoObj.files"
            alt=""
          />
          <div v-else>您的作品是"pdf"、 "docx"、 "doc"格式，如要查看作品，请下载后查看</div>
        </template>
        <!-- 以上是可支持word文稿和pdf格式文件上传的相关代码 -->

        <el-form-item
          label="重新上传"
          prop="file"
          v-if="props.studentApplyInfoObj.status !== 1"
        >
          <el-upload
            :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
            :auto-upload="false"
            :on-success="successFile1"
            :on-preview="uploadPreview1"
            :file-list="mydata.fileList1"
            :before-upload="beforeUpload"
            :show-file-list="true"
            :on-change="fileChange"
            :on-remove="fileRemove"
            :limit="1"
            :on-exceed="exceedFile"
          >
            <!-- :headers="mydata.headers" -->
            <!-- :data="mydata.fileData" -->
            <!-- name="files" -->
            <!-- :on-change="uploadChange1" -->
            <!-- :on-remove="uploadRemove1" -->
            <el-button type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-button type="success" plain @click="downWorks(info)">下载作品</el-button>
      </el-form>
      <template #footer v-if="props.studentApplyInfoObj.status !== 1">
        <div class="dialog-footer">
          <el-button type="primary" @click="submit(info)">确认</el-button>
          <el-button @click="clickReaNameCancel">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { Calendar } from "@element-plus/icons-vue";
import { User } from "@element-plus/icons-vue";
import { Document } from "@element-plus/icons-vue";
import { reactive, ref } from "vue";

import { ElMessage } from "element-plus";

import { useRouter } from "vue-router";

import { useIdGetUrl } from "@/utils/slide.js";
import { downFileToUrl,completeUrl} from "@/utils/utils.js";

import dayjs from "dayjs";

// 引入接口
import { studentApplyUpdate } from "@/api/personalCenter/myActivity/index.js";
import { getToken } from "@/utils/utils.js";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  xx: "/api/article/activity_file",
  form2: {
    file: [],
  },
  rules2: {
    file: [
      {
        required: true,
        message: "请上传附件",
      },
    ],
  },

  dialogVisible: false,
  dialogVisible1: false,
  dialogImageUrl1: "",
  fileList1: [],

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  headers: {
    token: getToken(),
  },
  fileData: { id: null },
});

//  可支持word文稿和pdf格式文件上传的相关代码 
const getFileType = (fileName) => {
  const extension = fileName.split(".").pop().toLowerCase();
  if (["jpg", "png", "gif", "jpeg"].includes(extension)) return "image";
  if (["pdf", "docx", "doc"].includes(extension)) return "document";
  return "unknown";
};
// .jpg .jpeg .png .gif,.doc,.docx,.pdf
// 以上是可支持word文稿和pdf格式文件上传的相关代码 


const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
  showUploadFileBtn: {
    type: Boolean,
    default: false,
  },

  showViewWorksBtn: {
    type: Boolean,
    default: false,
  },
  studentApplyInfoObj: {
    type: Object,
    default: () => {
      return {};
    },
  },
});





const formEl2 = ref(null);

const emits = defineEmits(["showUploadFileBtnClick"]);


function downWorks(val) { 
  let arr = val.files.split("/")
  let fileName = arr[arr.length-1]
  // downFileToUrl(val.files,fileName)
  downFileToUrl(completeUrl(val.files), fileName);
}








//按钮点击事件-点击跳转到详情页
function submitButton(type) {
  let path = "";
  if (type === 2) {
    path = "/layout/list/thematicDetails";
  } else if (type === 1) {
    path = "/layout/list/researchDetails";
  }
  router.push({
    path: path,
    query: { id: props.info.article_id },
  });
}

function btnClick(info) {
  emits("showUploadFileBtnClick", info);
}

//查看作品
function btnClick2(info) {
  // console.log(info);
  mydata.fileData.id = info.id;

  mydata.dialogVisible = true;
  emits("showUploadFileBtnClick2", info);
}

//////////////////////////////////////////////////////////

// 出版物许可证-文件上传成功
function successFile1(val) {
  mydata.form2.file.push(val.data.url);
  console.log(mydata.form2);
}

// 文件预览事件
function uploadPreview1(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible1 = true;
  // 赋值地址
  mydata.dialogImageUrl1 = file.url;
}

function beforeUpload(file) {
  const MAX_SIZE = 1024 * 1024 * 5; // 设定最大文件大小为5MB
  if (file.size > MAX_SIZE) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    return false; // 返回false停止上传
  }
  return true; // 返回true允许上传
}

function fileChange(file, fileList) {
  mydata.form2.file = fileList.map((item) => {
    return item.raw;
  });
  formEl2.value.validateField("file");
  // 清楚某个表单字段的校验状态
  setTimeout(() => {
    formEl2.value.clearValidate();
  }, 0);
}

function fileRemove(file, fileList) {
  mydata.form2.file = fileList.map((item) => {
    return item.raw;
  });
  formEl2.value.validateField("file");
  // 清楚某个表单字段的校验状态
  setTimeout(() => {
    formEl2.value.clearValidate();
  }, 0);
}

function exceedFile() {
  // 提示弹窗
  ElMessage({
    message: "只可上传一个文件",
    type: "warning",
  });
}

//登录的事件函数
function submit(info) {
  // console.log(mydata.form2.file);

  formEl2.value.validate((v) => {
    if (v) {
      console.log(mydata.form2.file[0]);
      let formDataObj = new FormData();
      formDataObj.append("id", info.id);
      formDataObj.append("name", mydata.userInfo.nickname);
      formDataObj.append("school", mydata.userInfo.school);
      // formDataObj.append('grade',mydata.userInfo.gradeId)
      // formDataObj.append('email',mydata.userInfo.email)
      formDataObj.append("files", mydata.form2.file[0]);
      studentApplyUpdate(formDataObj).then((res) => {
        // 提示弹窗
        ElMessage({
          message: res.msg,
          type: "success",
        });
        // 关闭弹窗
        mydata.dialogVisible = false;
        mydata.isSubmitFileUrl = true;
        // 跳转页面
        // router.push({ path: "/layout/list/personalCenter/myActivity" });
      });
    }
  });
}

// 实名认证
function clickReaNameCancel() {
  // 关闭弹窗
  mydata.dialogVisible = false;
}




</script>

<style scoped lang="scss">
.box {
  // background-color: red !important;
  width: 343px;
  // height: 414px;
  margin: 0 auto;
  //  border-top:1px solid #CCCCCC;
  // border: 1px solid rgb(21, 255, 0);
  background-color: #ffffff;
  box-shadow: 0px 5px 40px 0px #0000000d;

  padding: 16px;
  border-radius: 8px;
  position: relative;
}
.b-research {
  width: 100%;
  height: 100%;
  // margin-top: 40px;
  // border:1px solid rgb(0, 157, 255);
  background-color: #ffffff;

  // display: flex;
  // justify-content: space-between;
  > img {
    width: 100%;
    height: 201px;
    // margin-right: 24px;
    // border-radius: 8px;
    display: block;
    border-radius: 8px;
  }

  > .box-title {
    // position: relative;
    // width: 629px;
    .title-p {
      // width:100%;
      width: 100%;
      min-height: 24px;
      line-height: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;

      font-size: 16px;
      font-weight: 700;
      color: #333333;
      margin-top: 10px;

      cursor: pointer;
    }
    .title-p:hover {
      color: #009de0;
    }
    .icon-box {
      width: 100%;
      // height: 22px;
      line-height: 22px;

      white-space: nowrap; //不折行
      text-overflow: ellipsis; //文本溢出 用省略号显示
      overflow: hidden;

      // border: 1px solid red;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-bottom: 8px;
      p {
        margin-left: 8px;
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //文本溢出 用省略号显示
        overflow: hidden;
      }
    }
    .icon-box:nth-of-type(1) {
      margin-top: 18px;
    }

    .icon-box1:hover {
      color: #009de0;
    }
    :deep(.el-button.el-button--primary) {
      width: 134px;
      height: 35px;
      padding: 10px;
      border-radius: 30px;
      position: absolute;
      right: 0px;
      bottom: 0px;
      > span {
        color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
      }
    }

   
  }
}
.upload-file-btn {
  position: absolute;
  top: 16px;
  right: 16px;
}

//弹窗
:deep(.el-dialog) {
  border-radius: 0px;
}

:deep(.el-form-item.asterisk-left) {
  margin-top: 30px;
}

//上传文件长度
:deep(.el-upload-list.el-upload-list--text) {
  // border:1px solid red;
  max-width: 223px;
}

// 下载作品按钮
:deep(.el-button.el-button--success.is-plain) {
  width:166px;
  // margin-left:22px;
  // border: 1px solid red;
}
</style>
